import React, { useContext, useEffect, useRef, useState } from 'react';
import {
  eventEmitter,
  lang,
  sessid,
  dynRem,
  analytics,
  axiosConfig, esputnikTracker,
} from '../../common/baseData'
import { Accordion } from 'react-accessible-accordion';
import AdditionalProductGroup from './additionalProductGroup';
import BasketRightBlock from './basketRightBlock';
import EmptyBasket from './emptyBasket';
import CustomScroll from 'react-custom-scroll';
import 'react-custom-scroll/dist/customScroll.css';
import './Basket.css';
import axios from 'axios';
import { ClientWidthContext, BasketDispatchContext, BasketContext } from '../Context/ApplicationContextProvider'
import Lang from '../Lang/Lang';

function Basket(props) {

  //console.info(props.initialState)
  const basketHolderBlockRef = useRef(null);
  // ширина окна
  const clientWidth = useContext(ClientWidthContext);

  const dispatchBasket = useContext(BasketDispatchContext);
  const basketContext = useContext(BasketContext);
  // состояние скролла
  const [modalScrollPosition, setModalScrollPosition] = useState(0);
  // ссылка на родительский контейнер
  const modalRef = useRef(null);

  const [nonRemovableGoods, setNonRemovableGoods] = useState([]);
  const [opened, setOpened] = useState(false);
  // Основное состояние, приходит с сервера при обновлении данных
  const [state, setState] = useState(props.initialState);
  // Количество товаров корзины для GA4 (для сравнения до и после изменения)
  const ga4ItemsRef = useRef(null);
  if (ga4ItemsRef.current === null) ga4ItemsRef.current = sumGA4ItemsQuantity(props.initialState);

  useEffect(() => {
    esputnikTracker.StatusCart(basketContext.products, basketContext.stateHash);
  }, [basketContext.stateHash]);

  /**
   * Установка session storage данных о товарах корзины
   */
  useEffect(() => {
    refreshStorage(state);
  }, [state.basket]);

  /**
   * Инициализация событий
   */
  useEffect(() => {
    // Событие клика по кнопке редактировать на оформлении заказа
    let editButton = document.querySelector(
      '[data-container="basket"][data-use="open"]');
    if (editButton) {
      editButton.addEventListener('click', event => {
        event.preventDefault();
        openBasket();
      });
    }

    // Запрос на обнорвление корзины
    document.body.addEventListener('refreshBasketData', () => {
      //console.info('refreshBasketData event')
      refreshBasketData({}, true).then(() => {
        console.info('Basket refreshed');
      });
    });

    document.body.addEventListener('refreshBasketDataCoupon', (event) => {
      let coupon = event.detail !== null ? event.detail.COUPON : '';
      refreshBasketData({ 'coupon': coupon }).then(() => {
        console.info('Basket coupon refreshed');
      });
    });

    // обработка события изменения корзины через api
    eventEmitter.on('basketStateChanged', data => {
      // товар добавлен через api/Basket в обход шторки (допродажи в кредите), отслеживаем для GA4
      refreshBasketData({}, true, true, true).then(() => {
        console.info('Basket refreshed');
      });
    });

    // Событие добавления в корзину по старому образцу
    document.addEventListener('click', e => {
      let el = e.target;
      if (el.getAttribute('id') === 'ic-in-basket' || el.getAttribute('id') ===
        'ic-basket') {
        e.preventDefault();
        e.stopPropagation();
      }

      if (el.dataset.hasOwnProperty('container')
        && el.dataset.hasOwnProperty('use') &&
        el.dataset.hasOwnProperty('productId') &&
        el.dataset.container === 'buy' && el.dataset.use === 'order') { // Add to basket event
        e.preventDefault();
        e.stopPropagation();

        let productId = Number(el.dataset.productId);
        let addProductIds = String(el.dataset.addProductIds || '')
          .split(',')
          .map(id => parseInt(id))
          .filter(id => id > 0);

        if (productId && !inBasket(productId)) {
          eventEmitter.emit('addToCart', {
            productId: productId,
            addProductIds: addProductIds,
            node: el,
            source: 'page'
          });
        } else {
          eventEmitter.emit('openSmallCart');
        }
      }
    });

    eventEmitter.on('dropNonRemovableProducts', data => {
      if (!data.hasOwnProperty('basketIds') ||
        !Array.isArray(data.basketIds)) return;
      //console.info('dropNonRemovableProducts')
      setNonRemovableGoods(prev => prev.filter(id => !data.basketIds.includes(id)));
    });

    // событие установки / снятия блокировки удаления товаров
    eventEmitter.on('setNonRemovableProduct', data => {
      if (!data.hasOwnProperty('basketIds') ||
        !Array.isArray(data.basketIds)) return;
      // Если гарантию можно удалить, возвращает пустой массив
      if (data.basketIds.length === 0) {
        setNonRemovableGoods([]);
        return;
      }

      setNonRemovableGoods(prev => {
        const updatedSet = new Set([...prev, ...data.basketIds]); // Объединяем старые и новые ID
        return Array.from(updatedSet); // Преобразуем обратно в массив
      });
    });

    eventEmitter.on('addToCart', (data) => {
      //console.info('addToCart')
      if (!data.hasOwnProperty('productId')) return;

      let productId = data['productId'];
      let mainProductId = false;
      const addProductIds = Array.isArray(data.addProductIds)
        ? [...new Set(data.addProductIds.map(id => parseInt(id)).filter(id => id > 0))]
        : [];

      // при добавлении гарантии
      if (addProductIds.length > 0) {
        mainProductId = parseInt(data['productId']);
      } else if (data.hasOwnProperty('mainProductId') &&
        parseInt(data.mainProductId) > 0) {
        // если установлен основной товар
        mainProductId = parseInt(data.mainProductId);
      }

      // признак необходимости открытия окна
      let openWindow = true;
      if (data.hasOwnProperty('openWindow')) openWindow = data['openWindow'];

      let source = 'site';
      if (data.hasOwnProperty('source')) source = data['source'];

      addItemToCart(productId, openWindow, mainProductId, addProductIds, source);
    });

    eventEmitter.on('addToCartService', (data) => {
      console.info('addToCartService');
      if (!data.hasOwnProperty('productId')) return;

      let productId = data['productId'];
      let mainProductId = false;

      // при добавлении гарантии
      if (data.hasOwnProperty('addProductId') && data['addProductId']) {
        productId = [data['productId'], data['addProductId']];
        mainProductId = parseInt(data['productId']);
      } else if (data.hasOwnProperty('mainProductId') &&
        parseInt(data.mainProductId) > 0) {
        // если установлен основной товар
        mainProductId = parseInt(data.mainProductId);
      }

      // признак необходимости открытия окна
      let openWindow = true;
      if (data.hasOwnProperty('openWindow')) openWindow = data['openWindow'];

      let source = 'site';
      if (data.hasOwnProperty('source')) source = data['source'];

      addServiceToCart(productId, openWindow, mainProductId, source);
    });

    eventEmitter.on('addToCartSet', (data) => {
      console.info('addToCartSet', data);
      if (!data.hasOwnProperty('setId')) return;

      let setId = data['setId'];

      // признак необходимости открытия окна
      let openWindow = true;
      if (data.hasOwnProperty('openWindow')) openWindow = data['openWindow'];

      let source = 'site';
      if (data.hasOwnProperty('source')) source = data['source'];

      addSetToCart(setId, openWindow, source);
    });

    eventEmitter.on('removeFromCart', (data) => {
      console.info('removeFromCart');
      if (typeof data !== 'object' || !data.hasOwnProperty('cartId') ||
        !data.hasOwnProperty('productId')) return;
      removeItemFromCart(data);
    });

    eventEmitter.on('changeCartQuantity', (data) => {
      console.info('changeCartQuantity');
      if (typeof data !== 'object' || !data.hasOwnProperty('cartId') ||
        !data.hasOwnProperty('quantity')) return;

      let openWindow = data.hasOwnProperty('openWindow')
        ? data.openWindow
        : true;

      let source = 'site';
      if (data.hasOwnProperty('source')) source = data['source'];

      updateItemCartQuantity(data['cartId'], data['quantity'], openWindow, 0, 'add', source);
    });

    eventEmitter.on('openSmallCart', () => {
      console.info('openSmallCart');
      openBasket();
    });

    eventEmitter.on('closeBasket', () => {
      closeBasket();
    });

    // сброс данных о товарах в корзине после создания заказа
    eventEmitter.once('savedOrderStage', () => {
      window.localStorage.setItem('basketItemsMap', JSON.stringify({}));
      window.localStorage.setItem('basketItemsData', JSON.stringify([]));
    });

    checkOpenRequest();
    // send inited state
    eventEmitter.emit('basketInited');
  }, []);

  useEffect(() => {
    if (clientWidth < 660) {
      // добавляем обработчик события скролл
      if (modalRef.current) {
        modalRef.current.addEventListener('scroll', handleModalScroll);
      }
      // удаляем обработчик события, при размонтировании компонента
      return () => {
        if (modalRef.current) {
          modalRef.current.removeEventListener('scroll', handleModalScroll);
        }
      };
    }
  }, []);

  useEffect(() => {
    if (opened) {
      document.body.classList.add('modal-open');
      eventEmitter.emit('eSTrackerBasketRefresh', { needCheck: false });
      eventEmitter.emit('basketOpened');
      // Отправка события view_cart при открытии корзины
      sendViewCartEvent();
    } else {
      document.body.classList.remove('modal-open');
    }
  }, [opened]);

  // Добавление топ товаров в дополнительную корзину товаров
  useEffect(() => {
    if (Array.isArray(state.additional) && state.additional.length > 0) {
      // Проверяем, что первая группа не является уже созданной нами (чтобы избежать бесконечного цикла)
      const isFirstGroupCustom = state.additional[0]?.sort === 1 &&
        state.additional[0]?.name === "Топові товари";

      if (!isFirstGroupCustom) {
        const topItemsGroup = createTopItemsGroup(state.additional);

        setState(prevState => ({
          ...prevState,
          additional: [topItemsGroup, ...prevState.additional]
        }));
      }
    }
  }, [state.additional])

  // установка текущего значения скролла
  const handleModalScroll = () => {
    if (modalRef.current) {
      const currentPosition = modalRef.current.scrollTop;
      setModalScrollPosition(currentPosition);
    }
  };

  /**
   * Загрузка языковых сообщений
   * @param message
   * @return {string}
   */
  function getMessage(code) {
    return Lang.getMessage(code).
      replace('#MINPRICE_VALUE#',
        state.minPriceForOrder) || '';
  }

  /**
   * Проверяет находится ли товар в корзине
   * @param productId идентификатор товара
   * @return {boolean}
   */
  function inBasket(productId) {
    let inBasket = false;

    state.basket.forEach(record => {
      if (record.hasOwnProperty('PRODUCT_ID') && parseInt(record.PRODUCT_ID) ===
        parseInt(productId))
        inBasket = true;
    });

    return inBasket;
  }

  /**
   * Проверка на наличие ранего запроса на показ корзины
   */
  function checkOpenRequest() {
    if (window.sessionStorage.getItem('basketRequested') === 'true') {
      openBasket();
      window.sessionStorage.setItem('basketRequested', 'false');
    }
  }

  /**
   * Закрытие окна корзины
   */
  function closeBasket() {
    setOpened(false);
  }

  function openBasket() {
    setOpened(true);
  }

  /**
   * Обновление данных корзины пользователя
   * @param data
   * @param init
   * @param after_refresh
   * @param trackGA4 - отправка GA4 add_to_cart/remove_from_cart по изменениям корзины
   */
  function refreshBasketData(data, init, after_refresh = true, trackGA4 = !init) {
    return new Promise((resolve) => {
      // Подготовка данных для отправки
      let form_data = new FormData;

      if (typeof data === 'object') {
        for (let i in data) {
          if (!data.hasOwnProperty(i)) continue;

          if (Array.isArray(data[i])) {
            data[i].forEach(value => form_data.append(`${i}[]`, value));
          } else {
            form_data.append(i, data[i]);
          }
        }
      }

      form_data.append('lang', lang);

      // Начало загрузки
      eventEmitter.emit('showLoader');

      axios.post(state.ajaxPath, form_data, axiosConfig).then(response => {
        eventEmitter.emit('hideLoader');
        if (after_refresh) afterRefreshData(response.data, init, trackGA4);
        resolve(response.data);
      },
      ).catch(error => {
        console.error(error);
        eventEmitter.emit('hideLoader');
        resolve([]);
      });
    });
  }

  function afterRefreshData(response, init, trackGA4 = false) {
    //console.info('afterRefreshData')
    // Отправка GA4 событий до открытия корзины, чтобы view_cart шёл после add_to_cart
    const ga4Items = sumGA4ItemsQuantity(response);
    if (trackGA4) sendCartChangeEvents(ga4ItemsRef.current, ga4Items);
    ga4ItemsRef.current = ga4Items;

    refreshStorage(response);
    // Отправляем события
    if (!init) {
      sendEvents();
      eventEmitter.emit('basketUpdated', response.basket);
    }

    setState(response);
  }

  function refreshStorage(data) {

    try {
      // Просчитываем данные в корзине
      let basketItemsMap = {};
      let basketItemsData = [];

      data.basket.map(row => {
        // TODO изменить ключи и значения для использования нескольких одиннаковых товаров в корзине
        basketItemsMap[row.PRODUCT_ID] = row.ID;
        basketItemsData.push({
          cartId: row.ID,
          productId: row.PRODUCT_ID,
          quantity: row.QUANTITY,
          price: row.BASKET_PRICE.PRICE,
          currency: row.BASKET_PRICE.CURRENCY,
        });
      });

      // Сохраняем в storage
      window.localStorage.setItem('basketItemsMap', JSON.stringify(basketItemsMap));
      window.localStorage.setItem('basketItemsData', JSON.stringify(basketItemsData));

      dispatchBasket && dispatchBasket({
        type: 'update',
        payload: { products: basketItemsData, stateHash: data.stateHash },
      });
    } catch (err) {
      console.error('refreshStorage', err);
    }
  }

  /**
   * Отправка событий изменения твоаров корзины
   */
  function sendEvents() {
    eventEmitter.emit('eSTrackerBasketRefresh', { needCheck: true });
    // Отправляем событие обновления корзины
    document.body.dispatchEvent(new CustomEvent('basketUpdated'));
  }

  function addCoupon(coupon) {
    refreshBasketData({ 'coupon': coupon }).then(() => console.log('addCoupon'));
  }

  function removeCoupon(coupon) {
    refreshBasketData({ 'deleteCoupon': coupon.COUPON }).
      then(() => console.log('removeCoupon'));
  }

  function removeItemFromCart(data) {
    // Отпарвка запроса на удаление
    refreshBasketData({ sbblRemoveItemFromCart: data['cartId'] }).
      then(response => {
        if (Array.isArray(response.basket) && response.basket.length === 0) {
          closeBasket();
        }
        // Уведомление об удалении товара из корзины
        eventEmitter.emit('removedCartItem', {
          productId: data['productId'],
          basketItemsMap: JSON.parse(
            window.localStorage.getItem('basketItemsMap')),
          source: data.source || 'site'
        });
        // Отправка события ecommerce
        triggerRemoveEvent(data);
      });
  }

  function addItemToCart(id, openWindow = true, mainProductId = false, addProductIds = [], source = 'site') {
    // Отправка запроса на добавление твоара в корзину
    let data = { sbblAddItemToCart: id };

    // пробрасываем основной товар
    if (mainProductId > 0)
      data.mainProductId = mainProductId;

    // пробрасываем выбранную гарантию
    if (addProductIds.length > 0)
      data.addProductIds = addProductIds;

    refreshBasketData(data).then(() => {
      // Уведомление о добавлении товара в корзину
      eventEmitter.emit('addedToCart', {
        productId: id,
        basketItemsMap: JSON.parse(
          window.localStorage.getItem('basketItemsMap')),
        source: source
      });
      // Отправка события ecommerce
      triggerTrackerEvents(id);
      // Показ корзины
      if (openWindow) openBasket();
    });
  }

  function addServiceToCart(id, openWindow = true, mainProductId = false, source = 'site') {
    // Отправка запроса на добавление твоара в корзину
    let data = { sbblAddServiceToCart: id };

    // пробрасываем основной товар
    if (mainProductId > 0)
      data.mainProductId = mainProductId;

    refreshBasketData(data).then(() => {
      // Уведомление о добавлении товара в корзину
      eventEmitter.emit('addedToCart', {
        productId: id,
        basketItemsMap: JSON.parse(
          window.localStorage.getItem('basketItemsMap')),
        source: source
      });
      // Отправка события ecommerce
      triggerTrackerEvents(id);
      // Показ корзины
      if (openWindow) openBasket();
    });
  }

  function addSetToCart(id, openWindow = true, source = 'site') {
    // Отправка запроса на добавление твоара в корзину
    let data = { sbblAddSetToCart: id };

    refreshBasketData(data).then(() => {
      // Уведомление о добавлении товара в корзину
      eventEmitter.emit('addedToCart', {
        productId: id,
        basketItemsMap: JSON.parse(
          window.localStorage.getItem('basketItemsMap')),
        source: source
      });
      // Отправка события ecommerce
      triggerTrackerEvents(id);
      // Показ корзины
      if (openWindow) openBasket();
    });
  }

  function updateItemCartQuantity(id, quantity, openWindow = true, originProductId = 0, operation = 'add', source = 'site') {
    // Отправка запроса на обновление
    refreshBasketData({ sbblUpdateItemQuantity: id, sbblQuantity: quantity }).
      then(() => {
        let itemsData = [];
        try {
          itemsData = JSON.parse(window.localStorage.getItem('basketItemsData')) || [];
        } catch (e) { }
        let foundItem = itemsData.find(item => Number(item.cartId) === Number(id));
        let actualProductId = foundItem ? foundItem.productId : id;

        // Уведомление об обновлении записи в корзине
        eventEmitter.emit('updatedCartItem', {
          productId: actualProductId,
          cartId: id,
          quantity: quantity,
          basketItemsMap: JSON.parse(
            window.localStorage.getItem('basketItemsMap')),
          source: source
        });
        // Показ корзины
        if (openWindow) openBasket();

        if (originProductId !== 0) {
          if (operation === 'add') {
            // Отправка события ecommerce
            triggerTrackerEvents(originProductId, quantity, operation);
          } else if (operation === 'remove') {
            triggerTrackerEvents(originProductId, quantity, operation);
          }
        }
      });
  }

  /**
   * Суммирует количество по товарам из GA4 данных корзины, без подарков.
   * Одна гарантия может быть в нескольких записях для разных основных товаров
   * @param data - данные корзины (basket, ga4)
   * @returns {Object} {item_id: {item, quantity}}
   */
  function sumGA4ItemsQuantity(data) {
    const result = {};
    if (!data) return result;

    try {
      // подарок и платный товар различаются ценой записи корзины
      const giftKeys = (data.basket || [])
        .filter(row => row.GIFT)
        .map(row => `${row.PRODUCT_ID}|${Number(row.BASKET_PRICE.PRICE)}`);

      ((data.ga4 && data.ga4.items) || []).forEach(item => {
        if (giftKeys.includes(`${item.item_id}|${Number(item.price)}`)) return;
        const key = String(item.item_id);
        if (!result[key]) result[key] = { item: item, quantity: 0 };
        result[key].quantity += Number(item.quantity);
      });
    } catch (e) {
      console.error('sumGA4ItemsQuantity', e);
    }
    return result;
  }

  /**
   * Отправка GA4 add_to_cart/remove_from_cart по разнице корзины до и после изменения.
   * Покрывает добавление, +/−, удаление, изменение количества в кредите и замену гарантии сервером
   * @param before - результат sumGA4ItemsQuantity до изменения
   * @param after - результат sumGA4ItemsQuantity после изменения
   */
  function sendCartChangeEvents(before, after) {
    const diff = (from, to) => Object.keys(from)
      .map(id => ({ ...from[id].item, quantity: from[id].quantity - (to[id] ? to[id].quantity : 0) }))
      .filter(item => item.quantity > 0);
    const value = items => items.reduce((sum, item) => sum + Number(item.price) * item.quantity, 0);

    try {
      const removed = diff(before, after);
      const added = diff(after, before);

      removed.forEach(item => analytics.remove_from_cart({ total_price: value([item]), item: item }));
      if (added.length) analytics.add_to_cart({ total_price: value(added), items: added });
    } catch (e) {
      console.error('sendCartChangeEvents', e);
    }
  }

  /**
   * Отправка GA4 view_cart с данными всей корзины
   */
  function sendViewCartEvent() {
    const ga4 = state.ga4 || {};
    if (!Array.isArray(ga4.items) || ga4.items.length === 0) return;

    try {
      analytics.view_cart(ga4.total_price, ga4.items);
    } catch (e) {
      console.error('sendViewCartEvent', e);
    }
  }

  // Функция для создания новой записи с первыми товарами state.additional
  function createTopItemsGroup(additionalArray) {
    // Собираем первые товары из каждой группы
    const firstItems = additionalArray
      .map(group => group.items && group.items.length > 0 ? group.items[0] : null)
      .filter(item => item !== null);

    return {
      items: firstItems,
      name: "Топові товари",
      name_ru: "Топовые товары",
      name_ua: "Топові товари",
      opened: true,
      sort: 1,
      title: "Топові товари"
    };
  }

  /**
   * Trigger tracking events like Google Analytics
   * @param data - removed product data
   */
  function triggerRemoveEvent(data) {
    try {
      loadProductData(data['productId']).then(response => {
        if (response.success) {

          dataLayer.push({
            'ecommerce': {
              'currencyCode': 'UAH',
              'remove': {
                'products': [
                  {
                    'name': response.data.name,
                    'id': response.data.sku,
                    'price': response.data.price.toString(),
                    'brand': response.data.brand,
                    'category': response.data.categoryPath,
                    'variant': response.data.color,
                    'quantity': Number(data['quantity']),
                  }],
              },
            },
            'event': 'gtm-ee-event',
            'gtm-ee-event-category': 'Enhanced Ecommerce',
            'gtm-ee-event-action': 'Removing a Product from a Shopping Cart',
            'gtm-ee-event-non-interaction': 'False',
          });

          // GA4 remove_from_cart отправляется в afterRefreshData по изменениям корзины

        } else console.error(response.error);
      });
    } catch (e) {
      console.error(e);
    }
  }

  /**
   * Trigger tracking events like facebook pixel
   * @param id Product identifier
   * @param quantity Product identifier
   * @param operation Operation type
   */
  function triggerTrackerEvents(id, quantity = 1, operation = 'add') {
    try {
      loadProductData(id).then(function (response) {
        try {
          //console.info(response);
          eventEmitter.emit('MSAddToCart', { productId: response.data.sku });

          if (response.success) {
            if (operation === 'add') {
              if (window.fbq instanceof Object) {
                // facebook trigger event
                fbq('track', 'AddToCart', {
                  content_name: response.data.name,
                  content_category: response.data.category,
                  value: response.data.priceUAH,
                  currency: 'UAH',
                  content_ids: [response.data.id],
                  content_type: 'product',
                });
              }
              // GA4 add_to_cart отправляется в afterRefreshData по изменениям корзины

              dynRem.pushToDataLayer({
                'eventName': 'add_to_cart',
                'items': response.data.id,
                'price': response.data.priceUAH,
              });
            }
          } else {
            console.error(response.error);
          }
        } catch (error) {
          console.error(error);
        }
      }, function (error) {
        console.error(error);
      });
    } catch (e) {
      console.error(e);
    }
  }

  /**
   * Функция возвращает разделы товаров
   * @param categoryPath
   * @returns {{}}
   */
  function createCategoryFields(categoryPath) {
    const categories = categoryPath ?
      categoryPath.split('%').map(cat => cat.trim()) :
      [];
    const categoryFields = {};
    categories.forEach((category, index) => {
      categoryFields[`item_category${index === 0 ?
        '' :
        index + 1}`] = category;
    });
    return categoryFields;
  }

  /**
   * Отправка события перед переходом на страницу оформления заказа
   */
  function triggerTransitionCheckout() {
    // GA4 begin_checkout отправляется GTM при загрузке страницы оформления
    let data = {
      content_ids: [],
      content_type: 'product',
      value: 0,
      currency: 'UAH',
      num_items: 0,
    };

    let items = [].slice.apply(basketHolderBlockRef.current.querySelectorAll(
      '[data-container="offerDetailInfo"]'));

    // Начало загрузки (переход на страницу оформления)
    eventEmitter.emit('showLoader');

    if (items.length > 0) {
      items.forEach(item => {
        if (!(item instanceof HTMLElement) ||
          !item.hasAttribute('data-price')) return;
        data.value += Number(item.getAttribute('data-price'));
        data.content_ids.push(item.getAttribute('data-productId'));
        data.num_items++;
      });
    }

    // fbq вызывается только при живом пикселе (раньше guard стоял на входе в функцию)
    if (window.fbq) {
      fbq('track', 'InitiateCheckout', data);
    }
  }

  /**
   *
   * @param id
   * @returns {Promise<*>}
   */
  function loadProductData(id) {
    return refreshBasketData({ sbblGetProductData: id }, false, false);
  }

  /**
   * Возвращает открытые блоки дополнительных товаров
   */
  function preExpandedUuid() {
    let keys = [];
    state.additional.forEach((group, key) => {
      if (group.opened) keys.push(key);
    });
    return keys;
  }

  const basketHasItems = Array.isArray(state.basket) && state.basket.length > 0;
  const basketHasAdditional = basketHasItems && state.additional.length > 0;

  return (
    <>
      <div className={`modal-backdrop ${opened ? 'in' : ''}`}
        style={{ display: (!opened) ? 'none' : '' }} />
      <div className={`modal fade ${opened ? 'in' : ''}`} id="modal-basket"
        role="dialog"
        tabIndex="-1"
        onClick={e => {
          if (e.target.id === 'modal-basket') closeBasket();
        }}>
        <div className="modal-dialog" ref={modalRef}>
          <div
            className={`modal-content modal-content--basket ${basketHasAdditional
              ? 'basket-service'
              : 'without-basket-left'}`}
            id="site-small-cart-content"
            data-num={state.total.NUM_PRODUCTS}>
            <a href="#" className="close-modal" data-dismiss="modal"
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                closeBasket();
              }} />
            <div
              className={`modal-body modal-body--basket ${basketHasAdditional
                ? 'modal-body--basket-service'
                : 'bg-white'} ${!basketHasItems ? 'modal-body--empty-basket' : ''}`}>
              {opened ? (
                !basketHasItems ? (
                  <EmptyBasket getMessage={getMessage} />
                ) : basketHasAdditional ? (
                  <div className="basket-conteiner"
                    ref={basketHolderBlockRef}>
                    <div className="basket-left">
                      {
                        state.promoBanner !== null ?
                          <div className="min-1024:pt-[10px] lg-2:pt-[15px] pr-[25px] 660:mb-[25px] 660:pr-0">
                            <img
                              src={`${clientWidth > 1024 ? state.promoBanner.image_desktop : state.promoBanner.image_mob}`}
                              alt={state.promoBanner.title} />
                          </div> :
                          <></>
                      }
                      <CustomScroll heightRelativeToParent="calc(100% - 50px)"
                        allowOuterScroll={true}>
                        <div className="accordeon_items">
                          <div
                            className="accordeon_item basket-accordeon_main accordeon_item-accordeon">
                            <div className="accordeon_content">
                              <div className="basket-accordeon">
                                {
                                  Array.isArray(state.additional) &&
                                    state.additional.length ?
                                    <Accordion
                                      allowZeroExpanded={true}
                                      allowMultipleExpanded={true}
                                      preExpanded={preExpandedUuid()}
                                      className={'accordeon_items'}>
                                      {
                                        state.additional.map(
                                          (group, key) => {
                                            return <AdditionalProductGroup
                                              buyButtonColor={state.buyButtonColor}
                                              getMessage={getMessage}
                                              addToBasket={addItemToCart}
                                              group={group}
                                              key={key}
                                              uuid={key} />;
                                          })
                                      }
                                    </Accordion> :
                                    <></>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </CustomScroll>
                    </div>
                    <div className="basket-right">
                      <BasketRightBlock getMessage={getMessage}
                        closeBasket={closeBasket}
                        page={props.page}
                        nonRemovableGoods={nonRemovableGoods}
                        eventEmitter={eventEmitter}
                        showCreditButton={state.showCreditButton}
                        basket={state.basket}
                        addCoupon={addCoupon}
                        removeCoupon={removeCoupon}
                        removeFromBasket={removeItemFromCart}
                        updateBasketQuantity={updateItemCartQuantity}
                        basketHolderBlockRef={basketHolderBlockRef}
                        minPriceForOrder={state.minPriceForOrder}
                        minPriceForCredit={state.minPriceForCredit}
                        couponList={state.couponList}
                        coupon={state.coupon}
                        couponDiscountPrice={state.couponDiscountPrice}
                        refreshBasketData={refreshBasketData}
                        total={state.total}
                        orderPage={state.orderPage}
                        modalScrollPosition={modalScrollPosition}
                        triggerTransitionCheckout={triggerTransitionCheckout} />
                    </div>
                  </div>
                ) : (
                  <BasketRightBlock getMessage={getMessage}
                    closeBasket={closeBasket}
                    page={props.page}
                    nonRemovableGoods={nonRemovableGoods}
                    eventEmitter={eventEmitter}
                    showCreditButton={state.showCreditButton}
                    basket={state.basket}
                    addCoupon={addCoupon}
                    removeCoupon={removeCoupon}
                    removeFromBasket={removeItemFromCart}
                    updateBasketQuantity={updateItemCartQuantity}
                    basketHolderBlockRef={basketHolderBlockRef}
                    minPriceForOrder={state.minPriceForOrder}
                    minPriceForCredit={state.minPriceForCredit}
                    couponList={state.couponList}
                    coupon={state.coupon}
                    couponDiscountPrice={state.couponDiscountPrice}
                    refreshBasketData={refreshBasketData}
                    total={state.total}
                    orderPage={state.orderPage}
                    modalScrollPosition={modalScrollPosition}
                    triggerTransitionCheckout={triggerTransitionCheckout} />
                )
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Basket;